// Define the roles that can be used across the application
export const ROLES = {
    USER: 'user',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super-admin',
};

// Base API URL for the backend (can be replaced with real backend URL later)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.naf-cloudsystem.de/';

export const CHATBOT_WEBHOOK_URL = process.env.REACT_APP_CHATBOT_WEBHOOK_URL || 'https://n8n.naf-cloudsystem.de/webhook/chatbot-complete';

export const MAP_API_KEY = "2H_xIwx-3GN16ltp-Nr4_k_8hdBAOuXXlCFaN1UorOg";

// Storage keys used for storing data in localStorage
export const STORAGE_KEYS = {
    TOKEN: 'token',
    USER_INFO: 'user_info',
};

export const LIGHTCOLORS = {
    GreyScale10: '#EFF3F6',
    GreyScale20: '#E0E0E0',
    GreyScale30: '#C6C6C6',
    GreyScale40: '#A8A8A8',
    GreyScale50: '#8D8D8D',
    GreyScale60: '#6F6F6F',
    GreyScale70: '#525252',
    GreyScale80: '#393939',
    GreyScale90: '#262626',
    GreyScale100: '#0A1E06',
    HeadingLightBackground: '#0A1E06',
    BodyLightBackground: '#4A4A4A',
    DisabledLightBackground: '#B9B9B9',
    HeadingDarkBackground: '#FFFFFF',
    BodyDarkBackground: '#FFFFFF',
    DisabledDarkBackground: '#7A7A7A',
    Primary100: '#DDD8F8',
    Primary300: '#9586EA',
    Primary500: '#4C33DB',
    Primary700: '#000EA9',
    Secondary100: '#E3FCE5',
    Secondary300: '#ACF6B1',
    Secondary500: '#78F080',
    Secondary700: '#15C121',
    BackgroundDashboard: '#ECEDF8',
    BackgroundCard: '#FFFFFF',
    BackgroundMenu: '#FFFFFF',
    BaseWhite: '#FFFFFF',
    BaseBlack: '#0A1E06',
    Danger100: '#FFDBDB',
    Danger300: '#FF8F8F',
    Danger500: '#FF4141',
    Danger600: '#FF0000',
    Success100: '#85FFCA',
    Success300: '#00C670',
    Success500: '#009E5A',
    Success700: '#00522E',
    Warning100: '#FBF2D0',
    Warning300: '#F2D773',
    Warning500: '#EABB15',
    Warning700: '#BD9400',
    Alert100: '#FBE2D0',
    Alert300: '#F4A871',
    Alert500: '#EC6C12',
    Alert700: '#A44400'
};

export const DARKCOLORS = {
    GreyScale10: '#252525',
    GreyScale20: '#333333',
    GreyScale30: '#525252',
    GreyScale40: '#6F6F6F',
    GreyScale50: '#8D8D8D',
    GreyScale60: '#A8A8A8',
    GreyScale70: '#C6C6C6',
    GreyScale80: '#E0E0E0',
    GreyScale90: '#F6F6F6',
    GreyScale100: '#FCFCFC',
    HeadingLightBackground: '#F9F9F9',
    BodyLightBackground: '#BFBFBF',
    DisabledLightBackground: '#7A7A7A',
    HeadingDarkBackground: '#0A1E06',
    BodyDarkBackground: '#0A1E06',
    DisabledDarkBackground: '#646464',
    Primary100: '#DDD8F8',
    Primary300: '#9586EA',
    Primary500: '#7F88F3',
    Primary700: '#5C66D5',
    Secondary100: '#E3FCE5',
    Secondary300: '#ACF6B1',
    Secondary500: '#78F080',
    Secondary700: '#15C121',
    BackgroundDashboard: '#1B1B1B',
    BackgroundCard: '#2D2D2D',
    BackgroundMenu: '#2D2D2D',
    BaseWhite: '#FFFFFF',
    BaseBlack: '#0A1E06',
    Danger100: '#FFDBDB',
    Danger300: '#FF8F8F',
    Danger500: '#FF4141',
    Danger600: '#FF0000',
    Success100: '#85FFCA',
    Success300: '#00C670',
    Success500: '#009E5A',
    Success700: '#00522E',
    Warning100: '#FBF2D0',
    Warning300: '#F2D773',
    Warning500: '#EABB15',
    Warning700: '#BD9400',
    Alert100: '#FBE2D0',
    Alert300: '#F4A871',
    Alert500: '#EC6C12',
    Alert700: '#A44400'
};

// Define possible paths for routing
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    SALES_ANALYTICS: '/sales-analytics',
    TRANSACTIONS: '/transactions',
    BILLINGS: '/billings',
    VENDING_MACHINES: '/vending-machines',
    ADD_MACHINE: '/add-machine',
    MACHINE_DETAILS: '/machine-details',
    INVENTORY: '/inventory',
    ADVERTISEMENTS: '/advertisements',
    ADD_ADVERTISEMENT: '/add-advertisement',
    MEMBERSHIP_CARDS: '/customers',
    DISCOUNTS: '/discounts',
    COUPONS: '/coupons',
     RETURNS: '/returns',
    USERS: '/users',
    SERVICE_REQUEST: '/service-request',
    COMPLAINTS: '/complaints',
    SPARES: '/spares',
    CARTPAGE: '/cart',
    ORDERS: '/orders',
    ORDER_DETAILS: '/order-details',
    TAXES: '/taxes',
    TAXREPORT: '/taxReport',
    FRANCHISE: '/franchise',
    PAYOUT: '/payout',
    ADDFRANCHISE: '/add-franchise',
    ACADEMY: '/academy',
    HELP: '/help',
    ADMIN: '/admin',
    SUPER_ADMIN: '/super-admin',
    PROFILE: '/profile',
    Documentation: '/documentation',
    Faq: '/faq',
    TrustSafety: '/trustSafety',
};